import './content-toggle.scss';

document.addEventListener('DOMContentLoaded', function() {
    const contentToggleWrap = document.querySelector('.content-toggle-wrap');
    
    if (contentToggleWrap) {
        const navItems = contentToggleWrap.querySelectorAll('.content-nav-item');
        const mainItems = contentToggleWrap.querySelectorAll('.content-main-item');

        // Activate first item by default
        if (navItems.length > 0 && mainItems.length > 0) {
            navItems[0].classList.add('active');
            mainItems[0].classList.add('active');
        }

        // Add click event listeners to nav items
        navItems.forEach((navItem, index) => {
            navItem.addEventListener('click', function () {
                // Remove active class and aria attributes from all items
                navItems.forEach(item => {
                    item.classList.remove('active');
                    item.setAttribute('aria-selected', 'false');
                });
                mainItems.forEach(item => {
                    item.classList.remove('active');
                    item.setAttribute('hidden', 'true');
                });

                // Add active class and aria attributes to the clicked nav item and corresponding main item
                this.classList.add('active');
                this.setAttribute('aria-selected', 'true');
                mainItems[index].classList.add('active');
                mainItems[index].removeAttribute('hidden');
                mainItems.forEach(item => item.setAttribute('aria-hidden', 'true'));
                mainItems[index].setAttribute('aria-hidden', 'false');
            });

            navItem.addEventListener('keydown', function (event) {
                let newIndex = index;
                if (event.key === 'ArrowRight') newIndex = (index + 1) % navItems.length;
                else if (event.key === 'ArrowLeft') newIndex = (index - 1 + navItems.length) % navItems.length;
        
                navItems[newIndex].focus();
                navItems[newIndex].click();
            });
        });
    }
});